// extracted by mini-css-extract-plugin
module.exports = {"colorFontPrimary":"#333","component":"_3fUsX0HUvlISrBJ-PuooK4","hidden":"BCjFF0Oaj2k691PkOsvkV"};